import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import CentersInfoActions, { CentersInfoRedux, CentersInfoTypes } from '../Redux/CentersInfoRedux'

const centersInfoCRUDObservable = createCRUDObservable({
  mainRedux: CentersInfoRedux,
  reduxPath: 'centersInfo',
})

const paths = {
  attendance: { action: CentersInfoActions.getCentersAttendanceSuccess },
  overview: { action: CentersInfoActions.getCentersOverviewSuccess },
  'attendance/student-checkin': { action: CentersInfoActions.getCentersStudentsCheckinSuccess },
  'attendance/center-visit-average': { action: CentersInfoActions.getCentersVisitAverageSuccess },
  'attendance/daily': { action: CentersInfoActions.getCentersDailyAttendanceSuccess },
  'attendance/checkin': { action: CentersInfoActions.getCentersCheckinsSuccess },
  'attendance/active-checkins-distribution': { action: CentersInfoActions.getCentersActiveCheckinsSuccess },
  'attendance/teacher-distribution': { action: CentersInfoActions.getCentersTeacherDistributionSuccess },
  demographics: { action: CentersInfoActions.getCentersDemographicsSuccess },
  disenrollments: { action: CentersInfoActions.getCentersDisenrollmentsSuccess },
  'enrollments/net': { action: CentersInfoActions.getCentersNetSuccess },
  'enrollments/motives': { action: CentersInfoActions.getCentersMotivesSuccess },
  finances: { action: CentersInfoActions.getCentersFinancesSuccess },
  ratings: { action: CentersInfoActions.getCentersRatingsSuccess },
}

const getCentersInfoEpic = (action$, store, { Api }) =>
  action$.ofType(CentersInfoTypes.getCentersInfoRequest)
    .mergeMap(({ centerId, path }) => (
      Observable
        .fromPromise(Api.centersInfo.getCentersInfo(centerId, path)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [CentersInfoActions.getCentersInfoError(result.error)]
          }
          return [
            paths[path].action(result.data.data),
          ]
        })
    ))

export const centersInfoObservers = Object.assign({}, centersInfoCRUDObservable.observers,
  { getCentersInfoEpic })


export const centersInfoEpic = combineEpics(
  centersInfoCRUDObservable.epic,
  getCentersInfoEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CentersInfoObservable.js